import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DialogConfirmData = {
  header: string;
  body: string;
  leftButton: string;
  rightButton: string;
  onLeftClick: (e: Event) => void;
  onRightClick?: (e: Event) => void;
};

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrl: './dialog-confirm.component.scss',
  standalone: false
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: DialogConfirmData
  ) {}

  confirm = (e: Event) => {
    this.data.onLeftClick(e);
    this.dialogRef.close();
  };

  close = (e: Event) => {
    if (this.data.onRightClick) this.data.onRightClick(e);
    this.dialogRef.close();
  };
}
